import { css } from "lit";
import { formSectionStyles } from "../live-event-form.css";

export const styles = [
  formSectionStyles,
  css`
    .free-event-toggle {
      margin-bottom: 4px;
    }

    .form-row {
      container-type: inline-size;
    }

    .form-row wow-input {
      min-width: 0;
    }

    @container (min-width: 296px) {
      .form-row wow-input {
        --wow-input-title-min-height: 2lh;
        --wow-input-title-justify: flex-end;
      }

      .form-row wow-input:last-child {
        --wow-input-label-white-space: normal;
      }
    }
  `,
];
